module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('app-view', {
    on: {
      "open": _vm.onOpen,
      "restore": _vm.onRestore
    }
  }, [_c('div', {
    staticClass: "list"
  }, _vm._l((_vm.list), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "item"
    }, [_c('router-link', {
      staticClass: "poster",
      style: (_vm._f("bg")(item.thumb)),
      attrs: {
        "to": '/lives/' + item.id
      }
    }, [_c('div', {
      staticClass: "mask"
    }, [(item.push_status == 0) ? _c('div', {
      staticClass: "live orange"
    }, [_vm._v("待直播")]) : _vm._e(), _vm._v(" "), (item.push_status == 1) ? _c('div', {
      staticClass: "live red"
    }, [_vm._v("直播中")]) : _vm._e(), _vm._v(" "), (item.push_status == 2) ? _c('div', {
      staticClass: "live gray"
    }, [_vm._v("已结束")]) : _vm._e(), _vm._v(" "), (item.push_status == 3) ? _c('div', {
      staticClass: "live blue"
    }, [_vm._v("回放")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_c('div', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "time"
    }, [_vm._v("开播：" + _vm._s(_vm._f("datetime2")(item.starttime)))])])])]), _vm._v(" "), _c('div', {
      staticClass: "info"
    }, [_c('span', [_c('i', {
      staticClass: "icon icon-zongrenshu"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("unit")(item.online)))])]), _vm._v(" "), _c('span', [_c('i', {
      staticClass: "icon icon-guankancishu"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("unit")(item.hits)))])]), _vm._v(" "), _c('span', {
      staticClass: "space"
    }), _vm._v(" "), _c('a', {
      class: {
        on: item.good
      },
      on: {
        "click": function($event) {
          return _vm.onVote(item)
        }
      }
    }, [_c('i', {
      staticClass: "icon icon-a-lujing133"
    }), _vm._v(" "), (item.good) ? _c('span', [_vm._v(_vm._s(_vm._f("unit")(item.agree)))]) : _c('span', [_vm._v("点赞")])]), _vm._v(" "), (item.donate_url) ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.onShowSupport(item)
        }
      }
    }, [_c('i', {
      staticClass: "icon icon-a-Iconawesome-donate"
    }), _vm._v(" "), _c('span', [_vm._v("参与")])]) : _vm._e(), _vm._v(" "), (_vm.canShare && item.share_status > 0) ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.onShowShare(item)
        }
      }
    }, [_c('i', {
      staticClass: "icon icon-share"
    }), _vm._v("分享\n                ")]) : _vm._e()])], 1)
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-420fa455","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/lives/index.vue
// module id = 319
// module chunks = 0